import { render, staticRenderFns } from "./InternalMessageModal.vue?vue&type=template&id=090df903&scoped=true&"
import script from "./InternalMessageModal.vue?vue&type=script&lang=js&"
export * from "./InternalMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090df903",
  null
  
)

export default component.exports